import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IFilterComponent, SearchFilter } from "../../../infrastructure/iFilter-component";
import { FilterRecordService } from "../../../services/filter-record.service";
import { ReservationService } from "../../../services/reservation.service";
import { PatientSearch } from "src/app/model/patient";

@Component({
  selector: "app-reservation-his-filter-component",
  templateUrl: "./reservation-his-filter.component.html",
  styleUrls: ["./reservation-his-filter.component.css"],
})
export class ReservationHisFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private filterRecordService: FilterRecordService,
    private reservationService: ReservationService
  ) {
    this.form = this.formBuilder.group({
      finished: [false],
      patient: [null],
      date: [new Date(), [Validators.required]],
    });
  }


  get f() { return this.form.controls; }

  ngOnInit(): void {}

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  saveFilters(): void {
    this.filterRecordService.saveFilters("ReservationHisFilterComponent", this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters("ReservationHisFilterComponent", this.form);
  }

  async search(): Promise<any> {
    const values = this.form.getRawValue();
    return await this.reservationService.getReservationHis(
      this.form.controls.finished.value ? this.form.controls.finished.value : false,
      (this.form.controls.patient.value ? (<PatientSearch>this.form.controls.patient.value).Id : null),
      <Date>this.form.controls.date.value
    );
  }
}
